<script setup lang="ts">
  import { NumberFieldInput } from 'reka-ui';
  import type { HTMLAttributes } from 'vue';

  import { cn } from '@ui/utils/utils';

  import type { NumberFieldInputVariants } from '.';
  import { numberFieldInputVariants } from '.';

  export interface NumberFieldInputProps {
    align?: NumberFieldInputVariants['align'];
    class?: HTMLAttributes['class'];
    size?: NumberFieldInputVariants['size'];
  }

  const props = defineProps<NumberFieldInputProps>();
</script>

<template>
  <NumberFieldInput
    data-slot="input"
    :class="cn(numberFieldInputVariants({ size, align }), props.class)"
  />
</template>
